import { render, staticRenderFns } from "./ToHeadDashboard.vue?vue&type=template&id=00408158&scoped=true&"
import script from "./ToHeadDashboard.vue?vue&type=script&lang=js&"
export * from "./ToHeadDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ToHeadDashboard.vue?vue&type=style&index=0&id=00408158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00408158",
  null
  
)

export default component.exports